<template>
  <div class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm overflow-y-auto mt-[70px]">
    <div class="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
      <div
        class="inline-block transform overflow-hidden rounded-lg bg-white dark:bg-dark-800 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle"
      >
        <div class="bg-white dark:bg-dark-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <ExclamationTriangleIcon class="h-6 w-6 text-yellow-600" aria-hidden="true" />
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                Konfirmasi Perubahan Status
              </h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  Apakah Anda yakin ingin mengubah status item ini menjadi {{ newStatus ? 'Aktif' : 'Tidak Aktif' }}?
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            class="inline-flex w-full justify-center rounded-md border border-transparent bg-yellow-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
            @click="confirmChange"
          >
            Ya, Ubah Status
          </button>
          <button
            type="button"
            class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            @click="cancelChange"
          >
            Batal
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'ModalConfirmStatus',
  components: {
    ExclamationTriangleIcon
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    newStatus() {
      return !this.item.is_active
    }
  },
  methods: {
    async confirmChange() {
      try {
        await this.$store.dispatch('items/updateItemStatus', {
          item: this.item,
          outlet_id: this.item.outlet_id,
          newStatus: this.newStatus
        })
        this.$emit('closeModal')
        this.$emit('statusUpdated')
        this.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Berhasil mengubah status item',
          life: 3000
        })
      } catch (error) {
        console.error('Error updating item status:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response.data.message,
          life: 3000
        })
        this.$emit('closeModal')
        this.$emit('statusUpdated')
      }
    },
    cancelChange() {
      this.$toast.add({
        severity: 'warn',
        summary: 'Rejected',
        detail: 'Batal mengubah status item',
        life: 3000
      })
      this.$emit('closeModal')
    }
  }
}
</script>
